import React from 'react'
import { CCol, CFormInput, CFormLabel, CRow } from '@coreui/react-pro'

const GameSocial = ({ values, onChange }) => {
  return (
    <>
      <CRow>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="Facebook">
            Facebook
          </CFormLabel>
          <CFormInput
            id="facebook"
            value={values.facebook || ''}
            name="facebook"
            onChange={(event) => onChange('facebook', event.target.value)}
          />

          <small>
            <i> (Ex: https://www.facebook.com/myclubtap)</i>
          </small>
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="Twitter">
            X
          </CFormLabel>
          <CFormInput
            id="twitter"
            value={values.twitter || ''}
            name="twitter"
            onChange={(event) => onChange('twitter', event.target.value)}
          />
          <small>
            <i> (Ex: https://www.x.com/myclubtap)</i>
          </small>
        </CCol>

        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="Instagram">
            Instagram
          </CFormLabel>
          <CFormInput
            id="instagram"
            value={values.instagram || ''}
            name="instagram"
            onChange={(event) => onChange('instagram', event.target.value)}
          />
          <small>
            <i> (Ex: https://www.instagram.com/myclubtap)</i>
          </small>
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="Website">
            Website
          </CFormLabel>
          <CFormInput
            id="website"
            value={values.website || ''}
            name="website"
            onChange={(event) => onChange('website', event.target.value)}
          />
          <small>
            <i> (Ex: https://www.myclubtap.com)</i>
          </small>
        </CCol>
      </CRow>
    </>
  )
}

export default GameSocial
